import React from 'react';
import Button from '../Button/Button';
import Text from '../Text/Text';
import './FinishGame.css';

const FinishGame = (props) => {
    let countQuestion = props.rightAnswer.length;
    let badResult = countQuestion / 3;
    let countCorrect = 0;
    for(let i = 0; i < props.rightAnswer.length; i++) {
        if (props.rightAnswer[i] === 1) countCorrect++;
    }
    let valueResult = '';
    let cont = '';
        if (countQuestion === countCorrect) {
            valueResult = props.textGame.AllTasksDone[props.lang]; 
            cont = (
            <div>    
                <ul>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>  
                    <div className = 'sparrow BestResalt'></div>
                    <div className={(props.lang === 'fin') ? 'GameOverFin' : 'GameOverRus'} > </div>
            </div>
        )
        } 
        else {
            valueResult = props.textGame.SomeTasksDone[props.lang];
            if ( badResult < countCorrect ) {
                 cont = (
                    <div> 
                        <div className = 'sparrow GoodResalt'></div>
                        <div className={(props.lang === 'fin') ? 'GameOverFin' : 'GameOverRus'} > </div>
                    </div>
                    )
            }
            else {
                cont = (
                        <div>
                            <div className = 'sparrow BadResaltBottom'> </div>
                            <div className = 'sparrow BadResaltTop'></div>
                        </div>
                    ) 
                }
        };
        

    return (
        <div>
           {cont}
            <div className = 'sun'></div>
                <div className = 'resultsConting'>{countCorrect} / {countQuestion}</div>
                <Text className = 'Result'  value = {valueResult} /> 
            <Button className='UusiPeli' onClick={() => props.onClick('toStart')} value={props.textGame.PlayAgain[props.lang]} /> 

        </div>
    );
    };

export default FinishGame;